import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { localize } from 'wanderu-i18n';

import busLoader from 'wanderu-assets/images/fast-buses.png';
import baseAppConfig from 'wanderu-shellapp/src/config/baseApp.locales';

import styles from './BusLoader.scss';

function BusLoader(props) {
    const {
        alt,
        className,
        large,
        t,
    } = props;

    return (
        <div
            aria-label={t('loading')}
            className={classNames(
                className,
                styles.loaderContainer,
                { [styles.large]: large },
            )}
        >
            <img
                alt={alt || t('loading')}
                className={classNames(
                    styles.loader,
                    { [styles.large]: large },
                )}
                src={busLoader}
            />
        </div>
    );
}

BusLoader.propTypes = {
    alt: PropTypes.string,
    large: PropTypes.bool,
};

BusLoader.defaultProps = {
    large: false,
};

export { BusLoader };
export default localize(BusLoader, baseAppConfig.namespace);
